import { CalculatorOutlined, ContainerOutlined, FilePdfOutlined, NumberOutlined, UploadOutlined } from '@ant-design/icons';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { loadJson } from '../../../services/handleJson';
import { useTypedSelector } from '../../../store';
import { GRID_LG, GRID_MD, RowExt } from '../../../styles';
import { BLACK, BLUE } from '../../../styles/colors';
import { ButtonFullWidth, EmptyButton, LinkFullWidth } from '../../../styles/ui';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import { HomeDescWrapper, HomeMenuWrapper, HomeTitleWrapper } from '../HomeUI/HomeUI';

const MenuStart = () => {
  const hiddenFileInput = React.useRef<HTMLInputElement>(null);
  const userExists = useTypedSelector(state =>
    state.user.isNonAnonymousUserLoggedIn);
  const history = useHistory();
  const handleClick = () => {
    if (hiddenFileInput.current && hiddenFileInput) {
      hiddenFileInput.current.click();
    }
  };

  const { width } = useWindowSize();
  const Buttons = () => {
    const { t } = useTranslation();
    if (width < GRID_LG && userExists){
      return (
        <>
          <HomeMenuWrapper>
            <LinkFullWidth
              to={{ pathname: '/lawsuit' }}
            >
              <ButtonFullWidth
                type="primary"
                icon={<CalculatorOutlined />}
              >

                {t('home.menu.generate')}
              </ButtonFullWidth>
            </LinkFullWidth>
          </HomeMenuWrapper>
          <HomeMenuWrapper>
            <LinkFullWidth
              to={{ pathname: '/dashboard' }}
            >
              <EmptyButton
                style={{ width: '100%' }}
                color={BLACK}
                hoverColor="white"
                hoverBg={BLACK}
                icon={<ContainerOutlined />}
              >
                {t('home.menu.dashboard')}
              </EmptyButton>
            </LinkFullWidth>
          </HomeMenuWrapper>
        </>
      );
    }
    return (
      <>
        <HomeMenuWrapper>
          <LinkFullWidth
            to={{ pathname: '/lawsuit' }}
          >
            <ButtonFullWidth
              type="primary"
              icon={<CalculatorOutlined />}
            >
              {t('home.menu.generate')}
            </ButtonFullWidth>
          </LinkFullWidth>
        </HomeMenuWrapper>
        <HomeMenuWrapper>
          <LinkFullWidth
            to={{ pathname: '/ocr' }}
          >
            <EmptyButton
              style={{ width: '100%' }}
              icon={<FilePdfOutlined />}
              dotted
              {...{
                bgColor: 'white',
                color: BLACK,
                hoverColor: 'white',
                hoverBg: BLACK
              }}
            >
              {t('home.menu.pdf')}
              {' '}
              |
              <span style={{
                color: BLUE,
                fontWeight: 700,
                paddingLeft: 6,
              }}
              >
                AI
              </span>
            </EmptyButton>
          </LinkFullWidth>
        </HomeMenuWrapper>
        <HomeMenuWrapper>
          <ButtonFullWidth
            type="dashed"
            icon={<NumberOutlined />}
            onClick={() =>
              history.push('/lsCode')}
          >
            {t('home.menu.code')}
          </ButtonFullWidth>
        </HomeMenuWrapper>
      </>
    );
  };
  const { t } = useTranslation();
  return (
    <RowExt marginTop={width < GRID_LG ? 24 : 0}>
      <HomeTitleWrapper
        borderColor={BLUE}
        title={t('home.menu.title1')}
        level={width <= GRID_MD ? 4 : 5}
      />
      {/* <HomeDescWrapper>
        {t('home.menu.start')}
        {' '}
        -
        {' '}
        <Link
          to={{ pathname: '/' }}
        >
          {t('home.menu.works')}
        </Link>
      </HomeDescWrapper> */}
      <Buttons />
    </RowExt>
  );
};

export default MenuStart;